import moment from 'moment';
import React from 'react';
import Table from '../../../../../components/Table';
import { ICustomerQualityCertificateItem } from '../../../../../store/ducks/download-area/types';
import { Container } from './styles';
import { QCDownloadButton } from './QCDownloadButton';

interface IQualityCertifcateTableProps {
  customerQualityCertificateItems: ICustomerQualityCertificateItem[];
}

export const QualityCertifcateTable: React.FC<IQualityCertifcateTableProps> = ({
  customerQualityCertificateItems
}) => {
  const getColumns = () => {
    const columns = [
      {
        title: 'Ordem de venda',
        dataIndex: 'orderNumber',
        sorter: (
          a: ICustomerQualityCertificateItem,
          b: ICustomerQualityCertificateItem
        ) => a.orderNumber.localeCompare(b.orderNumber),
        render: (text: string) => <>{text}</>
      },
      {
        title: 'Nº da NF',
        dataIndex: 'invoiceNumber',
        sorter: (
          a: ICustomerQualityCertificateItem,
          b: ICustomerQualityCertificateItem
        ) => a.invoiceNumber.localeCompare(b.invoiceNumber),
        render: (invoiceNumber: string) => <>{invoiceNumber}</>
      },
      {
        title: 'Material Gerdau',
        dataIndex: 'sku',
        sorter: (
          a: ICustomerQualityCertificateItem,
          b: ICustomerQualityCertificateItem
        ) => a.sku.localeCompare(b.sku),
        render: (sku: string) => <>{sku}</>
      },
      {
        title: 'Data de faturamento',
        dataIndex: 'itemBillingDate',
        sorter: (
          a: ICustomerQualityCertificateItem,
          b: ICustomerQualityCertificateItem
        ) =>
          moment(a.itemBillingDate, 'YYYY-MM-DD').toDate().getTime() -
          moment(b.itemBillingDate, 'YYYY-MM-DD').toDate().getTime(),
        render: (billingDate: string) => (
          <span>
            {billingDate
              ? moment(billingDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
              : '-'}
          </span>
        )
      },
      {
        title: 'Descrição do produto',
        dataIndex: 'materialDescription',
        sorter: (
          a: ICustomerQualityCertificateItem,
          b: ICustomerQualityCertificateItem
        ) => a.materialDescription.localeCompare(b.materialDescription),
        render: (materialDescription: string) => <>{materialDescription}</>
      },
      {
        title: 'Certificado de qualidade',
        dataIndex: 'cqNumber',
        render: (cqNumber: string, record: ICustomerQualityCertificateItem) => (
          <QCDownloadButton
            qualityCertificateData={record}
            invoiceNumber={cqNumber}
          />
        )
      }
    ];

    return columns;
  };

  return (
    <Container>
      <Table
        columns={getColumns()}
        data={customerQualityCertificateItems}
        hasPagination
      ></Table>
    </Container>
  );
};
